import axios from "axios";
import defaultLang, {englishLang} from "../config";

export const baseurl = process.env.REACT_APP_URL;

export function isNone(variable){
    if(variable === null || variable === "" || variable === undefined) return true;
    return false;
  }

// La liste des thèmes/pôles
export async function alltheme(){

    var url = baseurl + "themes";

    var retour = null;

    await axios
    .get(url)
    .then(function (response){
        retour = response;
    })
    .catch(function (error){
        retour = error.response;
    });

    return retour;
}

// Get api info without data
export function apiinfo(completeInfo){

    var objectInfo = {
        totalItems: completeInfo.totalItems,
        totalPages: completeInfo.totalPages,
        currentPage: completeInfo.currentPage,
        itemDisplayNumber: completeInfo.itemDisplayNumber
    }

    return objectInfo;
}


// Enlever le style / tag 
export function extractPlainText (html){
  var tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || '';
};

// Formater la date
export function formattingDate (date){
    const language = JSON.parse(localStorage.getItem('lang')) || defaultLang;
    const d = new Date(date);
    var options = { year: 'numeric', month: 'long', day: 'numeric' };
    if(language.code === englishLang.code){
        return d.toLocaleDateString(['en'], options);
    }
    return d.toLocaleDateString(['fr'], options); 
    
};

// La liste des catégories/genre média
export async function listCategorie(type=null){
    var url = baseurl + 'genre/public/';
    if(!isNone(type)) url = url + '?typemedia='+type;
    else return []

    var retour = null;

    await axios.get(url)
        .then(function (response){
            retour = response;
        })
        .catch(function (error){
            retour = error.response;
        });

    return retour;
}

export async function listEntite(){
    var url = baseurl + 'entites/';
    
    var retour = null;

    await axios.get(url)
        .then(function (response){
            retour = response;
        })
        .catch(function(error){
            retour = error.response;
        });

    return retour;
}

export async function listLanguage() {
    var fullUrl = baseurl + 'languages';
    var reponse = { status: 0, data: [] };
    await axios.get(fullUrl)
        .then(function (response) {
            reponse = response;
        })
        .catch(function (error) {
            reponse = error.response ?? { status: 0, data: [] };
        })
    return reponse;
}